import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgAnalytics = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M7.36 4.62h9.28a3.76 3.76 0 0 1 3.76 3.76v5.094a3.76 3.76 0 0 1-3.76 3.76H7.36a3.76 3.76 0 0 1-3.76-3.76V8.381a3.76 3.76 0 0 1 3.76-3.76M12 3.001v1.63"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m8.037 12.808 2.705-2.703 2.082 2.082 3.14-3.14M15.673 21.003l-3.672-3.74-3.673 3.74"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgAnalytics);
export default ForwardRef;
